import { IUser } from "@rentiohq/shared-frontend/dist/types/auth.types";
import { IBroker } from "@rentiohq/shared-frontend/dist/types/broker.types";
import {
  IGroupActionContentBase,
  TGroupActionsLocale as TLocale,
} from "@rentiohq/shared-frontend/dist/types/groupAction.types";
import { ELocale } from "@rentiohq/shared-frontend/dist/types/i18n.types";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import {
  EGroupActionModalStep,
  EGroupActionType,
} from "./GroupActionsModal.types";

export const getType = (type: string) => {
  switch (type) {
    case EGroupActionType.Sms:
      return "SMS";

    case EGroupActionType.Email:
      return "email";

    default:
      return "";
  }
};

export const getLocaleKey = (locale: ELocale) => {
  switch (locale) {
    case ELocale.NL:
      return "nl";
    case ELocale.FR:
      return "fr";
    case ELocale.EN:
      return "en";
    default:
      return "nl";
  }
};

const getContentLabelKey = (type: string, locale: ELocale) => {
  if (type === EGroupActionType.Sms) {
    return `group_actions.modal.content.label.${getLocaleKey(locale)}`;
  }

  return "group_actions.modal.content.label";
};

const getGroupActionsPlaceholderValue = (
  type: string,
  locale: TLocale,
  lowerCaseType: string,
  broker?: IBroker,
  user?: IUser,
) => {
  return getLocalizedText(
    `group_actions.modal.${lowerCaseType}.content.placeholder`,
    {},
    0,
    locale,
  );
};

export const getLocalizedGroupActionsContent = (
  type: string,
  broker?: IBroker,
  user?: IUser,
): Record<TLocale, IGroupActionContentBase> => {
  const lowerCaseType = type.toLowerCase();
  const localizedContent = (locale: TLocale): IGroupActionContentBase => ({
    key: `group_actions_modal_${lowerCaseType}_content_${locale}`,
    label: getLocalizedText(getContentLabelKey(type, locale)),
    value: getGroupActionsPlaceholderValue(
      type,
      locale,
      lowerCaseType,
      broker,
      user,
    ),
  });

  return {
    nl_BE: localizedContent(ELocale.NL),
    fr_FR: localizedContent(ELocale.FR),
    en_UK: localizedContent(ELocale.EN),
  };
};

export const stepsForType: Record<EGroupActionType, EGroupActionModalStep[]> = {
  [EGroupActionType.Sms]: [
    EGroupActionModalStep.SelectAction,
    EGroupActionModalStep.AddContent,
  ],
  [EGroupActionType.Email]: [
    EGroupActionModalStep.SelectAction,
    EGroupActionModalStep.AddContent,
  ],
};
